import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
    selector: 'ukho-redirect',
    standalone: true,
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);
  private readonly authenticationService = inject(AuthenticationService);

  constructor() {
    this.authenticationService.handleLoginNavigation(this.router).pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }
}
